import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Drawer from 'material-ui/Drawer';
import cssVariables from 'src/common/styles/variables';
import { isProfile } from 'src/common/utils/guideItemTypes';
import getTopBannerOffsetStyles from 'src/common/utils/banner/getTopBannerOffsetStyles';
import Scrollbar from '../Scrollbar';
import UpsellRightSidebar from '../subscription/UpsellRightSidebar';
import DisplayAd from '../ads/DisplayAd';
import showProfileAdInContentArea from '../profile/utils/showProfileAdInContentArea';
import css from './right-side.module.scss';

/*
 * Adding pointer-events:none below makes it so that pointer events do not bubble up to the
 * target element. This includes scroll events that might block scrolling of the main content view.
 */

export function RightSide({
  isRightSideOpen,
  breakpoint,
  hideRightSidebarUpsell,
  matchUrl,
  guideId,
  shouldShowDesktopUpdateBanner,
  topBannerHeight,
  canShowAds,
} = {}) {
  if (!isRightSideOpen) {
    return null;
  }
  const drawerStyle = {
    boxShadow: 'none',
    pointerEvents: 'none',
    right: cssVariables['--browser-max-scrollbar-width'],
    paddingLeft: cssVariables['--rightSide-left-padding'],
    backgroundColor: cssVariables['--grey-3'],
    overflow: 'hidden',
  };

  if (shouldShowDesktopUpdateBanner) {
    Object.assign(drawerStyle, getTopBannerOffsetStyles(topBannerHeight));
  }

  const isProfileGuideItem = guideId ? isProfile(guideId) : false;
  const adSlotId = isProfileGuideItem
    ? 'profile_banner_right_side'
    : 'browse_banner_right_side';
  const adSlotName = isProfileGuideItem ? 'profile_side' : 'browse_side';
  const shouldRenderDisplayAd =
    canShowAds &&
    (!isProfileGuideItem || !showProfileAdInContentArea(breakpoint));

  const rightSideWidth = cssVariables['--rightSide-width'];
  const rightSideLeftPadding = cssVariables['--rightSide-left-padding'];

  return (
    <div className={css.wrapper}>
      <Drawer
        width={rightSideWidth}
        openSecondary
        docked
        open
        containerStyle={drawerStyle}
      >
        <Scrollbar
          width={rightSideWidth - rightSideLeftPadding}
          darkThemeEnabled
        >
          <div className={css.container}>
            {shouldRenderDisplayAd && (
              <DisplayAd
                key={adSlotId}
                id={adSlotId}
                slotName={adSlotName}
                isProfile={isProfileGuideItem}
                matchUrl={matchUrl}
                guideId={guideId}
              />
            )}
            {!hideRightSidebarUpsell && (
              <UpsellRightSidebar guideId={guideId} />
            )}
          </div>
        </Scrollbar>
      </Drawer>
    </div>
  );
}

RightSide.propTypes = {
  isRightSideOpen: PropTypes.bool,
  breakpoint: PropTypes.number.isRequired,
  guideId: PropTypes.string,
  hideRightSidebarUpsell: PropTypes.bool,
  matchUrl: PropTypes.string.isRequired,
  shouldShowDesktopUpdateBanner: PropTypes.bool,
  topBannerHeight: PropTypes.number,
  canShowAds: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    shouldShowDesktopUpdateBanner: get(
      state,
      'desktop.shouldShowDesktopUpdateBanner',
    ),
    topBannerHeight: get(state, 'app.topBannerHeight'),
  };
}

export default connect(mapStateToProps)(RightSide);
